import React from 'react';
import Main from "./DogInfo/Main.jsx"

function App() {
  return (
    <div className="App">
        <Main />
        
    </div>
  );
}

export default App;
